import React from 'react'

import { Trans, useTranslation } from 'react-i18next'

import AlertCard from '@components/myScores/MessagesView/AlertCard'
import { formatPriceInCents } from '@utils/formatters/number.formatter'

import type AccountAlert from '@models/AccountAlert'

interface Props {
  alert: AccountAlert
}
const DowngradeAccountAlert: React.FC<Props> = ({ alert }) => {
  const { t } = useTranslation()
  const { subscription } = alert
  if (!subscription) {
    return <p className="text-lg mb-2.5">{t('content.premiumMembershipEnded')}</p>
  }
  return (
    <AlertCard alert={alert}>
      <p className="text-lg mb-2.5">{t('content.cancelledSubscription')}</p>
      {!!subscription.send_refund_date && (
        <p className="mb-2.5">
          {t('content.cancellationAmount', {
            amount: formatPriceInCents(subscription.quote.initial_charge, {
              showDouble0ForCents: true,
            }),
          })}
        </p>
      )}
      <p className="mb-2.5">
        <Trans
          i18nKey="content.cancellationNotice"
          values={{ planName: subscription.displayable_plan_name }}
        />
      </p>
    </AlertCard>
  )
}

export default DowngradeAccountAlert
